// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-nIP","rootNoMargin":"styles_rootNoMargin__1r-wd"};